/**
 * Pre-load and decode the payment modal's icons and logo so they
 * appear instantly when the modal opens — no flash, no blank box.
 *
 * Vite hashes the URLs at build time, so we import them here and
 * re-export the URLs alongside the warm-up helpers.
 */
import EXPRESS_ICON from "@/assets/Expresspay.png";
import REFERENCIA_ICON from "@/assets/Rerencia.png";
import VISA_ICON from "@/assets/Visa.png";
import BERASTAYS_LOGO from "@/assets/berastays-logo-pin.png";

export { EXPRESS_ICON, REFERENCIA_ICON, VISA_ICON, BERASTAYS_LOGO };

const ASSETS = [EXPRESS_ICON, REFERENCIA_ICON, VISA_ICON, BERASTAYS_LOGO];

let warmed = false;
let linksInjected = false;

export function preloadPaymentAssets(): void {
  if (warmed || typeof window === "undefined") return;
  warmed = true;
  try {
    ASSETS.forEach((src) => {
      const img = new Image();
      img.decoding = "async";
      img.src = src;
      // .decode() forces the browser to fully decode the bitmap so the
      // first <img> mount paints in the same frame.
      if (typeof img.decode === "function") {
        img.decode().catch(() => {
          /* noop — fallback: browser will still cache via .src */
        });
      }
    });
  } catch {
    /* noop */
  }
  injectPaymentAssetPreloadLinks();
}

export function injectPaymentAssetPreloadLinks(): void {
  if (linksInjected || typeof document === "undefined") return;
  linksInjected = true;
  try {
    const isNative =
      typeof (window as any).Capacitor !== "undefined" &&
      (window as any).Capacitor.isNativePlatform?.() === true;
    if (isNative) return; // No benefit on local WebView
    ASSETS.forEach((href) => {
      const link = document.createElement("link");
      link.rel = "preload";
      link.as = "image";
      link.href = href;
      document.head.appendChild(link);
    });
  } catch {
    /* noop */
  }
}
